var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nothing-here-block"},[_vm._v("\n  "+_vm._s(_vm.__("File suppressed by a .gitattributes entry or the file's encoding is unsupported."))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }